export default __webpack_public_path__ + "static/media/receipt.b1d9034d.svg";